import z from 'zod';
import { MEMBERSHIP_PRODUCTS_FETCH_TYPE } from '../type/product';
import { MEMBERSHIP_EVENT_TYPE } from '../type/event';
import { NumericStringSchema } from './schema';
import { MEMBERSHIP_STATE } from '../type';

export const MembershipProductsReqBodySchema = z.object({
  type: z.nativeEnum(MEMBERSHIP_PRODUCTS_FETCH_TYPE),
  membershipIds: z.array(z.string()),
  auth_uid: z.string().nullable(),
});

export const MembershipEventTypeSchema = z.nativeEnum(MEMBERSHIP_EVENT_TYPE);

export const UpdateMembershipEventReqBodySchema = z.object({
  type: MembershipEventTypeSchema,
  membershipId: NumericStringSchema,
  token: z.string(),
});

export const DeleteMembershipEventReqBodySchema = z.object({
  type: MembershipEventTypeSchema,
  membershipId: NumericStringSchema,
});

// 필요할 때 export
const MembershipSchema = z.object({
  id: z.string(),
  state: z.nativeEnum(MEMBERSHIP_STATE),
});

// `memberships` 테이블 DML 데이터 검증
export const MembershipListSchema = z.array(MembershipSchema);

export const DeleteMembershipsSchema = z.object({
  membership_ids: z.array(NumericStringSchema),
});
